module.exports = __webpack_public_path__ + "img/vehicle_front.87357497.png";